<div class="row">
  <div class="col-md-12">
    <div class="form-group label-floating">
      <label class="control-label">Which year?</label>
      <div class="btn-group">
        <label
          class="btn btn-raised"
          [ngClass]="{ active: !displayCurrentYear }"
          (click)="switchSelectedYear(false)"
        >
          <input type="radio" autocomplete="off"/> {{ selectedYear - 1 }}
        </label>
        <label
          class="btn btn-raised"
          [ngClass]="{ active: displayCurrentYear }"
          (click)="switchSelectedYear(true)"
        >
          <input type="radio" autocomplete="off"/> {{ selectedYear }}
        </label>
      </div>
    </div>
  </div>
</div>


<div class="mt-4">

  @if (isAdmin) {
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <a
          class="nav-link"
          [ngClass]="{
            show: isDefaultSelectedTab === 'selectedUserTab',
            active: isDefaultSelectedTab === 'selectedUserTab'
          }"
          href="javascript:void(0)"
          (click)="setSelectedTab('selectedUserTab')"
        >
          Selected User
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          [ngClass]="{
            show: isAdmin && isDefaultSelectedTab === 'allUsersTab',
            active: isAdmin && isDefaultSelectedTab === 'allUsersTab'
          }"
          href="javascript:void(0)"
          (click)="setSelectedTab('allUsersTab')"
        >Selected month</a
        >
      </li>
    </ul>
  }


  <div class="tab-content">

    <!-- Selected User tab -->
    <div
      id="selectedUserTab"
      class="tab-pane fade"
      [ngClass]="{
        show: isDefaultSelectedTab === 'selectedUserTab',
        active: isDefaultSelectedTab === 'selectedUserTab'
      }"
    >
      @if (isAdmin) {
        <div class="row">
          <div class="col-md-6">
            <div class="form-group label-static">
              <label class="control-label" for="selectedUser">IT'z</label>
              <select
                id="selectedUser"
                name="selectedUser"
                class="form-control"
                [(ngModel)]="selectedUser"
                (ngModelChange)="getBilledHours()"
              >
                @for (user of users; track user) {
                  <option [ngValue]="user">
                    {{ user.userFirstName }} {{ user.userName }}
                  </option>
                }
              </select>
            </div>
          </div>
          @if (selectedUser) {
            <div class="col-md-6">
              <p class="client-informations font-weight-bold">
                Client :
                {{ (selectedUser.mission?.label || "BENCH") }}
              </p>
            </div>
          }
        </div>
      }

      <div style="margin-top: 20px; margin-bottom: 20px">
        @if (!isAdmin) {
          <p>Hello {{ displayedLogin | firstNamePipe }},</p>
          <p>
            Here is a summary of assigned hours to your client mission.
          </p>
          <p style="margin-bottom: 20px">
            If you would notice a difference between your official client
            timesheet and the below one - please crosscheck your entries for days
            not with the client<br/>
            (ie: day&#64;xpertiz office - training - holidays - sickness)
          </p>
        }

        @for (stat of billingStats; track stat) {
          <div class="row">
            <div class="col-md-3 text-right">
              <span style="white-space: nowrap; line-height: 40px">{{
                stat.month | date : "MMMM y"
              }}</span>
              &nbsp;
              <a (click)="downloadTimesheet(stat.month)"
              ><img src="../../../css/img/excel.png" alt="Excel"
              /></a>
            </div>
            <div class="col-md-9">
              <progressbar
                [value]="calculateProgress(stat.billed, stat.totalBillable)"
                [label]="getProgressbarLabel(stat.billed, stat.totalBillable, stat.displayInDayFormat)"
                color="#E8902A"
              >
              </progressbar>
            </div>
          </div>
        }
      </div>
    </div>

    <!-- Selected month tab -->
    <div
      id="allUsersTab"
      class="tab-pane fade"
      [ngClass]="{
        show: isDefaultSelectedTab === 'allUsersTab',
        active: isDefaultSelectedTab === 'allUsersTab'
      }"
    >

      <!-- Month selector -->
      <div class="month-selector-row">
        <label class="month-label">Month:</label>
        <select
          class="month-select"
          [(ngModel)]="selectedMonth"
          name="selectedMonth"
          (ngModelChange)="onMonthChange()"
        >
          @for (month of monthNames; track $index) {
            <option [ngValue]="$index + 1">{{ month }}</option>
          }
        </select>
      </div>

      <!-- Users grouped by client then mission -->
      @for (group of groupedUsers; track $index) {
        @if (group.type === 'client') {
          <div class="client-group">
            <div class="client-group-header">{{ group.clientName }}</div>
            @for (mission of group.missions; track mission.missionLabel) {
              <div class="mission-subgroup">
                <div class="mission-subgroup-header">{{ mission.missionLabel }}</div>
                @for (user of mission.users; track user.id) {
                  @let stat = getUserMonthStat(user);
                  <div class="user-month-row">
                    <div class="user-month-name">{{ user.userFirstName }} {{ user.userName }}</div>
                    <div class="user-month-progress">
                      @if (stat) {
                        <progressbar [value]="calculateProgress(stat.billed, stat.totalBillable)"
                          [label]="getProgressbarLabel(stat.billed, stat.totalBillable, stat.displayInDayFormat)"
                          color="#F5C1F2"></progressbar>
                      } @else if (userBillingMap.has(user.id)) {
                        <span class="no-billing-data">No data for this month</span>
                      } @else {
                        <span class="no-billing-data">Loading…</span>
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        } @else {
          <div class="client-group">
            <div class="client-group-header">{{ group.missionLabel }}</div>
            @for (user of group.users; track user.id) {
              @let stat = getUserMonthStat(user);
              <div class="user-month-row">
                <div class="user-month-name">{{ user.userFirstName }} {{ user.userName }}</div>
                <div class="user-month-progress">
                  @if (stat) {
                    <progressbar [value]="calculateProgress(stat.billed, stat.totalBillable)"
                      [label]="getProgressbarLabel(stat.billed, stat.totalBillable, stat.displayInDayFormat)"
                      color="#F5C1F2"></progressbar>
                  } @else if (userBillingMap.has(user.id)) {
                    <span class="no-billing-data">No data for this month</span>
                  } @else {
                    <span class="no-billing-data">Loading…</span>
                  }
                </div>
              </div>
            }
          </div>
        }
      }
    </div>

  </div>
</div>
